import { render, staticRenderFns } from "./loadVolumeStatistics.vue?vue&type=template&id=425713ce&scoped=true&"
import script from "./loadVolumeStatistics.vue?vue&type=script&lang=js&"
export * from "./loadVolumeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425713ce",
  null
  
)

export default component.exports